<template>
  <div>
    <div class="pos-fnb-final-ticket-wrapper vh-100">
      <button class="btn-modal-close" @click="callClose()">&times;</button>
      <div class="h4 font-weight-bold text-center mt-5">Add Cash</div>
      <div class="my-5 d-flex align-items-center">
        <div class="col-10 mx-auto">
          <div class="row">
            <div class="col-12 align-self-center">
              <div class="w-100 fnb-movie-ticket">
                <div class="row mx-0">
                  <div class="col-5 fnb-mt-cut py-2">
                    <div class="col-12 px-0">                   
                    
                      <div class="row">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Card Number</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold">
                             {{ getSelectedTopUpCashCard.cash_card_number || "-" }}
                          </h6>
                        </div>
                      </div>
                      <div class="row border-bottom mb-2">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Customer</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold">
                             {{ getCustomerName }}
                          </h6>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Balance</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold">
                            {{ Currency | uppercase }}&nbsp;{{
                              currFormat(getSelectedTopUpCashCard.remaining_balance)
                            }}
                          </h6>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Cash Added</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold text-success">
                            +{{ Currency | uppercase }}&nbsp;{{
                              currFormat(getcashInputForCashCard)
                            }}
                          </h6>
                        </div>
                      </div>
                      
                      <div class="row">
                        <div class="col-5">
                          <h6 class="my-2 font-weight-bold">Current Balance</h6>
                        </div>
                        <div class="col-7 text-right">
                          <h6 class="my-2 font-weight-bold">
                            {{ Currency | uppercase }}&nbsp;{{currFormat(cashCardTopUpData.balance_amount)}}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-7 border-left-dashed py-2">
                    <div class="mt-5 font-weight-bold fs-16 text-center">
                      {{ cashCardTopUpData.message }}
                    </div>
                    <div class="mt-2 font-weight-bold fs-16 text-center">
                     Current Balance {{ Currency | uppercase }}&nbsp;{{currFormat(cashCardTopUpData.balance_amount)}}
                    </div>
                  </div>
                </div>
              </div>
            </div>

           
            <div class="col-12 text-center mt-5">
              <div class="row">
              <div class="col-12">
                <button @click="OnClickPrint()" class="btn-blue-lg">
                  Print Receipt
                </button>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="d-none"
      ref="print_cash_Card"
    >
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { authenticationService } from "@/services/AuthenticationService";
import Printd from "printd";
import moment from "moment";
import MasterService from "@/services/MasterService";
import PosService from "@/services/PosService";
import AddComment from "@/components/Partials/AddTransactionComment";

// import OCTemplate from "../PosBookingContainer/PrintTicketTemplates/One_Copy_Template";
// import ThreeCTemplate from "../PosBookingContainer/PrintTicketTemplates/3_Copies_Template";
// import DefaultTemplate from "../PosBookingContainer/PrintTicketTemplates/Default_Template";
import SReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/sales_receipts";
import BOFnbSReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/bo&fnb_sales_receipt";
import TPSReceipt from "@/components/Pages/PosBookingContainer/ReceiptTemplates/Tickets_Products_sales_receipt";

import { EventBus } from "@/main";
import { BASEURL } from "@/config/index";

export default {
  components: {
    // "onecopy-template": OCTemplate,
    // "threecopy-template": ThreeCTemplate,
    // "default-template": DefaultTemplate,
    "BO-sales-receipt": SReceipt,
    "Bo-Fnb-sales-receipt": BOFnbSReceipt,
    "Ticket-Product-sales-receipt": TPSReceipt,
    AddComment
  },
  data() {
    return {
      currentDate: "",
      SelectedCountryCode: "",
      phoneError: null,
      phonenumber: null,
      TemplateList: [],
      EjsData: null,
      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" }
      ],
      Countries: [],
      CodeListCopy: [],
      searchCode: "",
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries"
      }
    };
  },
  props: {
    onClickHandler: {
      type: Function
    },
    onClickCloseButton: {
      type: Function
    },
    Currency: {
      type: String,
      default: ""
    },
  },
  computed: {
    DirectPrint() {
      return this.$store.getters.DirectPrint;
    },
    isReprint() {
      return this.$store.getters.isReprint;
    },
    cashCardTopUpData() {
        console.log("this.$store.getters.gettopData", this.$store.getters.gettopData)
        return this.$store.getters.gettopData;
    },
    getcashInputForCashCard() {
        console.log("this.$store.getters.getcashInputForCashCard", this.$store.getters.getcashInputForCashCard)
        return this.$store.getters.getcashInputForCashCard;
    },
    getSelectedTopUpCashCard() {
        console.log("this.$store.getters.getSelectedTopUpCashCard", this.$store.getters.getSelectedTopUpCashCard)
        return this.$store.getters.getSelectedTopUpCashCard;
    },
     getCustomerDetails() {
      return this.$store.getters.getCustomerDetails;
    },
    getCustomerName() {
        let name = ``
        if(this.$store.getters.getSelectedTopUpCashCard && this.$store.getters.getSelectedTopUpCashCard.customer_id) {
            name = `${this.getSelectedTopUpCashCard.first_name} ${this.getSelectedTopUpCashCard.last_name ? this.getSelectedTopUpCashCard.last_name : ''}`
        } else if(this.$store.getters.getSelectedTopUpCashCard.hasOwnProperty('is_guest_user') && this.$store.getters.getSelectedTopUpCashCard.is_guest_user == 'Y') {
          name = `${this.getSelectedTopUpCashCard.guest_first_name} ${this.getSelectedTopUpCashCard.guest_last_name ? this.getSelectedTopUpCashCard.guest_last_name : ''}`
        } else if(this.$store.getters.getCustomerDetails && this.$store.getters.getCustomerDetails.hasOwnProperty('cust_id')) {
          name = `${this.$store.getters.getCustomerDetails.first_name} ${this.$store.getters.getCustomerDetails.last_name ? this.$store.getters.getCustomerDetails.last_name : ''}`
        } else if(this.$store.getters.getSelectedTopUpCashCard && this.$store.getters.getSelectedTopUpCashCard.is_street_sale == 'Y') {
            name= `Street Sale`
        } else {
            name = '-'
        }
        return name;
    },
  },
  beforeMount() {
    this.currentDate = moment().format("DD.MM.YY HH:mm");
    const { cinema_id } = this.secureStore.get("USINFO");
  },
  methods: {
    OnClickPrint() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
          let loader = this.$loading.show();
          try {
            if (this.$socket) {
              this.$socket.emit("on_print_ticket", {
                baseurl: BASEURL,
                ttype: "cash_card_receipt",
                cash_card_id: this.cashCardTopUpData.cash_card_id,
                cash_card_log_id: this.cashCardTopUpData.cash_card_log_id,
                isReprint: this.isReprint
              });
            }
          } catch (err) {
            console.log("ERROR in SOcket", err);
          } finally {
            setTimeout(() => loader.hide(), 1000);
          }
        } else {
          this.onPrintHandler();
        }
    },
    onPrintHandler: function(sb_id, cinema_id) {
      let loader = this.$loading.show();
      let payload = {
        cash_card_id: this.cashCardTopUpData.cash_card_id,
        cash_card_log_id: this.cashCardTopUpData.cash_card_log_id,
        isReprint: this.isReprint
      }
      PosService.getCashCardReceipt(payload)
        .then(async response => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            const p = new Printd();
            if (this.$refs.print_cash_Card && this.EjsData != null) {
              p.print(this.$refs.print_cash_Card, []);
            }
          });
        })
        .catch(this._CatchError);
    },
    callClose: function() {
      try {
        if (this.$socket) {
          this.$socket.emit("home_page");
        }
      } catch (err) {}
      this.onClickCloseButton();
    },
  }
};
</script>

<style>
.pos-fnb-final-ticket-wrapper {
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  position: fixed;
  height: calc(100vh - 75px);
  background-color: #fff;
}

.pos-fnb-final-ticket-wrapper .btn-modal-close {
  top: -12px;
  right: 15px;
  position: absolute;
}

.fnb-movie-ticket {
  border-radius: 5px;
  box-shadow: 1px 1px 3px 1px #808080ad;
}

.fnb-movie-table {
  width: 100%;
}

.fnb-mt-cut::before,
.fnb-mt-cut::after {
  content: "";
  width: 25px;
  right: -13px;
  z-index: 22;
  height: 25px;
  display: block;
  border-radius: 50%;
  position: absolute;
  background-color: #fff;
}

.fnb-mt-cut::before {
  top: -13px;
  border-bottom: 2px solid grey;
}

.fnb-mt-cut::after {
  bottom: -13px;
  border-top: 2px solid grey;
}

.fnb-movie-table td:nth-child(2) {
  width: 60px;
  text-align: right;
}

/* .ticket-section {
  text-align: center;
  height: calc(100% - 52.913385826px);
  padding: 8px;
}
.ticket-wrapper {
  width: 302.36220472px;
  height: 100%;
  border: 1px solid #000000;
} */
.vh-100 {
  height: 100vh!important
}
td {
  padding: 0px;
}
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/CashCardFinalPage.vue